import { useEffect } from 'react';
import { useGallerySelection } from '@/context/GallerySelectionContext';

/**
 * Clears a selected child folder/album when "Show Folders & Albums" (DM-2518) hides the band,
 * so the selection bar doesn't keep describing a chip that's no longer on screen.
 *
 * Distinct from `useReconcileChildSelection`, which handles a child that stops existing (trashed,
 * moved, renamed away) — its children list doesn't change when this setting toggles, so it never
 * fires for this. This hook is the only thing reacting to the setting itself.
 */
export const useClearSelectionOnHiddenChildren = (showFoldersAndAlbums: boolean) => {
  const { selection, deselectAllItems } = useGallerySelection();

  useEffect(() => {
    if (!showFoldersAndAlbums && selection.kind === 'nodes') {
      deselectAllItems();
    }
  }, [showFoldersAndAlbums, selection.kind, deselectAllItems]);
};
